import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import SwapIcon from "@material-ui/icons/SwapHoriz";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
// import defaultMatchTimes from "../../constants/DefaultMatchTimes";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = (theme) => ({
  removeButton: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },
});

class EditMatchDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.schedule.editMatch}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText
              style={{
                backgroundColor: "#eee",
                padding: 10,
                borderRadius: 5,
                textAlign: "center",
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ width: "40%" }}>
                  <div
                    style={{ fontWeight: 500, fontSize: 12, marginBottom: 5 }}
                  >
                    {languages.schedule.home}
                  </div>
                </div>

                <div style={{ width: "20%" }}></div>

                <div style={{ width: "40%" }}>
                  <div
                    style={{ fontWeight: 500, fontSize: 12, marginBottom: 5 }}
                  >
                    {languages.schedule.away}
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "stretch" }}>
                <div style={{ width: "40%" }}>
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: 5,
                      padding: 5,
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      wordBreak: "break-word",
                    }}
                  >
                    {this.props.switched ? this.props.team2 : this.props.team1}
                  </div>
                </div>

                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IconButton
                    aria-label="Change"
                    onClick={this.props.handleSwitch}
                  >
                    <SwapIcon />
                  </IconButton>
                </div>

                <div style={{ width: "40%" }}>
                  <div
                    style={{
                      backgroundColor: "white",
                      borderRadius: 5,
                      padding: 5,
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      wordBreak: "break-word",
                    }}
                  >
                    {this.props.switched ? this.props.team1 : this.props.team2}
                  </div>
                </div>
              </div>
            </DialogContentText>

            <FormControl fullWidth>
              <InputLabel htmlFor="referee">
                {this.props.tournament.useJudges
                  ? languages.referees.judge
                  : languages.referees.referee}
              </InputLabel>
              <Select
                value={this.props.selectedReferee}
                onChange={this.props.handleChange}
                inputProps={{
                  name: "referee",
                  id: "referee",
                }}
              >
                <MenuItem value="">
                  <em>{languages.referees.none}</em>
                </MenuItem>
                {this.props.referees
                  .sort((a, b) =>
                    a.name.localeCompare(b.name, undefined, {
                      numeric: true,
                      sensitivity: "base",
                    })
                  )
                  .map((referee) => (
                    <MenuItem key={referee.id} value={referee.id}>
                      {referee.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <br />
            <br />
            {this.props.tournament.numRefereesPerMatch > 1 && (
              <FormControl fullWidth style={{ marginBottom: 20 }}>
                <InputLabel htmlFor="referee2">
                  {this.props.tournament.useJudges
                    ? languages.referees.judge2
                    : languages.referees.referee2}
                </InputLabel>
                <Select
                  value={this.props.selectedReferee2}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "referee2",
                    id: "referee2",
                  }}
                >
                  <MenuItem value="">
                    <em>{languages.referees.none}</em>
                  </MenuItem>
                  {this.props.referees.map((referee) => (
                    <MenuItem key={referee.id} value={referee.id}>
                      {referee.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {this.props.tournament.numRefereesPerMatch > 2 && (
              <FormControl fullWidth style={{ marginBottom: 20 }}>
                <InputLabel htmlFor="referee3">
                  {this.props.tournament.useJudges
                    ? languages.referees.judge3
                    : languages.referees.referee3}
                </InputLabel>
                <Select
                  value={this.props.selectedReferee3}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "referee3",
                    id: "referee3",
                  }}
                >
                  <MenuItem value="">
                    <em>{languages.referees.none}</em>
                  </MenuItem>
                  {this.props.referees.map((referee) => (
                    <MenuItem key={referee.id} value={referee.id}>
                      {referee.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {this.props.tournament.numRefereesPerMatch > 3 && (
              <FormControl fullWidth style={{ marginBottom: 20 }}>
                <InputLabel htmlFor="referee4">
                  {this.props.tournament.useJudges
                    ? languages.referees.judge4
                    : languages.referees.referee4}
                </InputLabel>
                <Select
                  value={this.props.selectedReferee4}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "referee4",
                    id: "referee4",
                  }}
                >
                  <MenuItem value="">
                    <em>{languages.referees.none}</em>
                  </MenuItem>
                  {this.props.referees.map((referee) => (
                    <MenuItem key={referee.id} value={referee.id}>
                      {referee.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {this.props.tournament.numRefereesPerMatch > 4 && (
              <FormControl fullWidth style={{ marginBottom: 20 }}>
                <InputLabel htmlFor="referee5">
                  {this.props.tournament.useJudges
                    ? languages.referees.judge5
                    : languages.referees.referee5}
                </InputLabel>
                <Select
                  value={this.props.selectedReferee5}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "referee5",
                    id: "referee5",
                  }}
                >
                  <MenuItem value="">
                    <em>{languages.referees.none}</em>
                  </MenuItem>
                  {this.props.referees.map((referee) => (
                    <MenuItem key={referee.id} value={referee.id}>
                      {referee.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <FormControl
              fullWidth
              aria-describedby="weight-helper-text"
              style={{ width: "100%" }}
            >
              <InputLabel htmlFor="match-duration">
                {languages.schedule.modifiedMatchDuration}
              </InputLabel>
              <Input
                id="match-duration"
                type="number"
                name="duration"
                // placeholder={
                //   this.props.tournament.matchDuration !== undefined
                //     ? this.props.tournament.matchDuration.toString()
                //     : defaultMatchTimes.matchDuration.toString()
                // }
                value={this.props.duration}
                onChange={this.props.handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    {languages.schedule.minutes}
                  </InputAdornment>
                }
              />
            </FormControl>
            <Button
              className={this.props.classes.removeButton}
              fullWidth
              style={{ marginTop: 15 }}
              onClick={this.props.removeMatchFromSchedule}
              color="secondary"
              variant="outlined"
            >
              {this.props.removeFromScheduleConfirm
                ? languages.tournament.areYouSure
                : languages.schedule.removeMatchFromSchedule}
            </Button>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {languages.general.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}

EditMatchDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditMatchDialog);
